import type React from 'react';

import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import { cn } from '~/styling';

export const slidesvar = cva(['mb-5', 'h-full', 'w-full'], {
  variants: {
    intent: {
      slide1: [
        'bg-primary-2-20 flex flex-col-reverse items-center justify-center gap-6 p-10 md:flex-row',
      ],
      slide2: ['container flex flex-col items-center justify-start gap-10 bg-[#061318] md:gap-24'],
      slide3: ['flex bg-white md:flex'],
      slide4: ['flex-col items-start justify-start gap-24 bg-[#2C1F44] px-10 md:flex md:flex-row'],
      slide5: ['md:block'],
      slide6: ['flex-col gap-6 bg-[#EEE5FF] md:flex'],
      slide7: [
        'flex flex-col-reverse items-center justify-between gap-4 bg-[url(/static/homepage/holi.png)] bg-cover bg-center bg-no-repeat py-4 md:flex-row md:items-center md:gap-8 md:px-6',
      ],
      slide8: [
        'flex flex-col-reverse items-center justify-between gap-4 bg-[#FFF4EE] bg-[repeating-conic-gradient(rgba(232,64,43,0.35)_0%_25%,rgba(242,123,167,0.35)_25%_50%)] bg-[length:72px_72px] py-6 md:flex-row md:items-center md:gap-8 md:px-6',
      ],
    },
  },
});

type divprops = React.HTMLAttributes<HTMLDivElement> & {
  varient?: VariantProps<typeof slidesvar>['intent'];
  slideContent: React.ReactNode;
};

export default function Homepageslides({ varient, slideContent, ...props }: divprops) {
  return (
    <div className={cn(slidesvar({ intent: varient }))} {...props}>
      {slideContent}
    </div>
  );
}
